/** Vuetify 다크 모드 — localStorage 키 (plugins/vuetify.js·CoreHeader와 공통) */
export const THEME_STORAGE_KEY = 'solvit-theme-dark';

/**
 * 저장값이 있으면 그대로 사용, 없으면 다크 모드 기본
 * (사용자가 헤더에서 바꾼 경우에만 localStorage에 기록됨)
 */
export function readInitialDarkMode() {
  if (typeof window === 'undefined') {
    return true;
  }
  const saved = localStorage.getItem(THEME_STORAGE_KEY);
  if (saved === null) {
    return true;
  }
  return saved === 'true';
}

export function persistDarkMode(isDark) {
  localStorage.setItem(THEME_STORAGE_KEY, String(!!isDark));
}
